import {
  reactQueryGet,
  reactQueryPatch,
} from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { createQueryKeyFactory } from "@circle-react/lib/queries/createQueryKeyFactory";
import { queryClient } from "@circle-react/providers/QueryClient/reactQueryConfig";
import { queryOptions, useMutation } from "react-query";

export const reviewSettingsKey = createQueryKeyFactory("review-settings");

export type ReviewPromptAfterDays = 7 | 14 | 30 | 60 | 90;

export interface ReviewSettings {
  collect_reviews_enabled: boolean;
  collect_reviews_enabled_at: string | null;
  prompt_after_days: ReviewPromptAfterDays;
}

interface ReviewSettingsResponse {
  community_setting: ReviewSettings;
}

interface ReviewSettingsUpdate {
  collect_reviews_enabled?: boolean;
  prompt_after_days?: ReviewPromptAfterDays;
}

export const reviewSettingsQueries = {
  show: () =>
    queryOptions({
      queryKey: reviewSettingsKey.key("show"),
      queryFn: async () => {
        const response = await reactQueryGet<ReviewSettingsResponse>(
          internalApi.settings.reviewSettings.show(),
        );
        return response.community_setting;
      },
    }),
};

export const reviewSettingsInvalidations = {
  all: () =>
    queryClient.invalidateQueries({ queryKey: reviewSettingsKey.root() }),
};

export const useUpdateReviewSettingsMutation = () =>
  useMutation({
    mutationFn: async (update: ReviewSettingsUpdate) => {
      const response = await reactQueryPatch<
        ReviewSettingsResponse,
        { community_setting: { review_settings: ReviewSettingsUpdate } }
      >(internalApi.settings.reviewSettings.update(), {
        community_setting: { review_settings: update },
      });
      return response.community_setting;
    },
    onSuccess: settings => {
      queryClient.setQueryData(reviewSettingsKey.key("show"), settings);
    },
    onError: () => {
      void reviewSettingsInvalidations.all();
    },
  });
